module.exports = __webpack_public_path__ + "static/media/app-sc.e65cd55c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/app-sc.png
// module id = 1136
// module chunks = 0